
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import CustomLandingPage from '@/components/landing/CustomLandingPage';
import { LandingProvider } from '@/context/LandingContext';
import CustomBusinessFooter from '@/components/Footer/CustomBusinessFooter';
import { getBusinessSettings } from '@/utils/businessService';
import { BusinessSettings } from '@/utils/businessService';
import { useLandingPage } from '@/hooks/useLandingPage';

const CustomBusinessLanding: React.FC = () => {
  const [businessSettings, setBusinessSettings] = useState<BusinessSettings | null>(null);
  const { settings, isLoading, businessName } = useLandingPage();
  const navigate = useNavigate();
  
  useEffect(() => {
    const loadBusinessSettings = async () => {
      try {
        const settings = await getBusinessSettings();
        setBusinessSettings(settings);
      } catch (error) {
        console.error('Failed to load business settings:', error);
      }
    };
    
    loadBusinessSettings();
  }, []);
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header isLoggedIn={false} />
      <main className="flex-grow">
        <LandingProvider 
          settings={settings} 
          isLoading={isLoading} 
          businessName={businessName}
        >
          <CustomLandingPage />
        </LandingProvider>
      </main>
      <CustomBusinessFooter 
        terms={businessSettings?.terms}
        privacy={businessSettings?.privacyPolicy}
        contactEmail={businessSettings?.contactEmail}
      />
    </div>
  );
};

export default CustomBusinessLanding;
